import React, { useEffect, useState } from "react";
import API from '../Services/PlayPoint'
import APIS from '../Services/MemberShip'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlayPointList from "../Components/PlayPointList";
import moment from "moment";


const PlayPoint = () => {
    const [paymentAmount, setPaymentAmount] = useState("")
    const [playPoint, setPlayPoint] = useState("")
    const [memberShip, setMemberShip] = useState([])
    const [error, setError] = useState({});
    const [selectMembership, setSelectMembership] = useState("")
    const perPage = 10
    const [currentPage, setCurrentPage] = useState(1);
    const [playPointList, setPlayPointList] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [id, setId] = useState([])
    const [createdDate, setCreatedDate] = useState("");
    const [status, setStatus] = useState("");
    const [memberShipStatus, setMembershipStatus] = useState("")

    useEffect(() => {
        getMemberShipList();
        getPlayPointList()
    }, [currentPage]);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "paymentAmount":
                setPaymentAmount(value);
                break;
            case "playPoint":
                setPlayPoint(value);
                break;
            case "selectMembership":
                setSelectMembership(value);
                break;
            default:
                break;
        }
    };


    const getMemberShipList = async () => {
        try {
            const response = await APIS.getMemberShip({ is_active: true });
            setMemberShip(response?.data?.data?.rows);
        } catch (error) {
            setError((prevErrors) => ({
                ...prevErrors,
                duration: "Failed to fetch membership data.",
            }));
            handleError(error);
        }
    };


    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };


    const handleChange = (e) => {
        const value = e.target.value;
        setSelectMembership(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.selectMembership;
            return updatedErrors;
        });
    };


    const getPlayPointList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getPlayPoint(payload);
            // console.log("response data....", response?.data?.data?.count)
            setPlayPointList(response?.data?.data?.rows)
            setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };


    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getPlayPointList();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };
    const changeStatus = async (id, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changePlayPointStatus(id, updatedStatus);
            if (response.status === 200) {
                setPlayPointList((prevLocation) =>
                    prevLocation.map((item) =>
                        item.id === id ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(
                    `SkyCoins ${updatedStatus ? "Activated" : "De-Activated"} successfully!`
                );
                getMemberShipList();
            } else {
                console.log("Error updating status:", response);
                toast.error("Failed to update the status. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.log("Error in status toggle:", error);
            toast.error("Failed to update the status. Please try again.");
        }
    };


    const handleGetData = async (pointId) => {
        // console.log("....", pointId)
        try {
            const response = await API.getPlayPoint({ id: pointId });
            const fetchedData = response?.data?.data?.rows?.[0];
            //  console.log("fetchdata...", fetchedData)
            if (fetchedData) {

                setId(fetchedData.id);
                setPaymentAmount(fetchedData?.payment_amount)
                setPlayPoint(fetchedData?.play_point)
                setSelectMembership(fetchedData?.membership_id)
                setCreatedDate(fetchedData?.createdAt)
                setStatus(fetchedData?.is_active)
                setMembershipStatus(fetchedData?.membership_name)

            } else {
                toast.error("Failed to fetch SkyCoins details.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error fetching data:", error);
        }
    };

    const updatePlayPointData = async () => {
        if (!validateFields()) return;
        try {
            const payload = {
                payment_amount: paymentAmount,
                play_point: playPoint,
                membership_id: selectMembership,
            };
            const response = await API.updatePlayPointStatus(id, payload);
            //  console.log('f', response.data)
            if (response?.status === 200) {
                toast.success(response?.data?.message);
                getPlayPointList()
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Failed to update SkyCoins. Please try again.");
            }
        } catch (error) {
            if (error.response.status === 404) {
                toast.error('Resource not found (404)');
            }
            else if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            console.error("Error updating designation:", error);
            toast.error("An unexpected error occurred. Please try again later.");
        }
    }

    const validateFields = () => {
        const errors = {};
        const priceRegex = /^\d+(\.\d{1,2})?$/;
        if (!paymentAmount || String(paymentAmount).trim() === "") {
            errors.paymentAmount = "Payment amount is required";
        } else if (!priceRegex.test(String(paymentAmount))) {
            errors.paymentAmount = "paymentAmount must be a valid number (e.g., 100 or 100.50)";
        }
        const PlayPoint = /^\d+(\.\d{1,2})?$/;
        if (!playPoint || String(playPoint).trim() === "") {
            errors.playPoint = "SkyCoins is required";
        } else if (!PlayPoint.test(String(playPoint))) {
            errors.playPoint = "SkyCoins must be a valid number (e.g., 100 or 100.50)";
        }
        // if (!selectMembership) {
        //     errors.selectMembership = "Membership is required";
        // }

        setError(errors);
        return Object.keys(errors).length === 0;
    };

    return (
        <div>

            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added SkyCoins</h4>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Payment Amount</th>
                                        <th>SkyCoins</th>
                                        {/* <th>Membership</th> */}
                                        <th>Status</th>
                                        <th>Created-Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {playPointList.map((item, index) => (
                                        // console.log("item play point", item),
                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>

                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetData(item.id)}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                        data-bs-toggle="modal" data-bs-target="#myModal"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    {/* {localStorage.getItem("location_id") !== item.id && ( */}
                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}
                                                                    >
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>
                                                                    {/* )} */}
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.payment_amount}</td>
                                            <td>{item.play_point}</td>
                                            {/* <td>{item.membership_name}</td> */}
                                            <td>{item?.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination justify-content-center mt-4">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        >
                                            Previous
                                        </button>
                                    </li>

                                    {getPageNumbers().map((page, index) => (
                                        <li
                                            key={index}
                                            className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                        >
                                            {page === "..." ? (
                                                <span className="page-link">...</span>
                                            ) : (
                                                <button className="page-link" onClick={() => handlePageChange(page)}>
                                                    {page}
                                                </button>
                                            )}
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                </div>
            </div>

            <section>
                <div className="modal" id="myModal" data-bs-backdrop="static">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Update SkyCoins</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="my-1">Payment Amount <span style={{ color: "red" }}>*</span></label>
                                        <input type="text" className="form-control"
                                            value={paymentAmount}
                                            onChange={(e) => handleFieldChange(e, "paymentAmount")}
                                        ></input>
                                        {error?.paymentAmount && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.paymentAmount}
                                            </span>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="my-1">SkyCoins <span style={{ color: "red" }}>*</span></label>
                                        <input type="text" className="form-control"
                                            value={playPoint}
                                            onChange={(e) => handleFieldChange(e, "playPoint")}
                                        ></input>
                                        {error?.playPoint && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.playPoint}
                                            </span>
                                        )}
                                    </div>

                                    {/* <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="dddMamber">Membership <span style={{ color: "red" }}>*</span></label>
                                            <select
                                                className="form-select"
                                                id="ddMamber"
                                                value={selectMembership}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select</option>
                                                {memberShip.map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>

                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary" onClick={updatePlayPointData} >Update</button>
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">SkyCoins Details</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>Payment Amount</th>
                                                            <th>SkyCoins</th>
                                                            {/* <th>MemberShip</th> */}
                                                        </tr>
                                                        <tr>
                                                            <td>{paymentAmount}</td>
                                                            <td>{playPoint}</td>
                                                            {/* <td>{memberShipStatus}</td> */}
                                                        </tr>
                                                        <tr>
                                                            <th>Created Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer />
        </div>

    );
};

export default PlayPoint;